import { render, staticRenderFns } from "./Governanca.vue?vue&type=template&id=f3742830&"
import script from "./Governanca.vue?vue&type=script&lang=js&"
export * from "./Governanca.vue?vue&type=script&lang=js&"
import style0 from "./Governanca.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports